<ng-container *ngIf="allFeaturedCategories?.length !== 0">
    <div class="">
        <ng-container
            *ngIf="
                environmentVariables.CATEGORY_STYLE === 'slider' ||
                environmentVariables.CATEGORY_STYLE === 'none'
            "
        >
            <h3
                class="lable title py-2 px-3 border-background-none"
                style="font-size: 1.4rem !important"
            >
                {{ "productDetails.featuredCategories" | translate }}
            </h3>
            <div class="container-category pt-2 pb-2">
                <div class="swiper-container">
                    <swiper [config]="CateSwiperConfig" class="mySwiper">
                        <ng-template
                            swiperSlide
                            *ngFor="let category of allFeaturedCategories"
                            class="swiper-slide pb-4"
                        >
                            <div class="p-0 my-3" style="cursor: pointer">
                                <a
                                    style="margin: 0px auto !important"
                                    class="brand-item"
                                    (click)="rediectToProductPage(category)"
                                >

                                    <div class="singleCategory">
                                        <div
                                            class="imgContainer"
                                            [ngClass]="{
                                                'radius-50 shadow':
                                                    categoryTypeData?.isSqure ==
                                                    'round'
                                            }"
                                        >
                                            <img
                                                loading="lazy"
                                                [ngClass]="{
                                                    'radius-50 shadow':
                                                        categoryTypeData?.isSqure ==
                                                        'round'
                                                }"
                                                [src]="category.image"
                                                [alt]="category.image"
                                                class="swiper-lazy"
                                                onError="this.src='./assets/images/placeholder200.jpg';"
                                                default="./assets/images/placeholder200.jpg"
                                            />

                                            <div>
                                                <h3 class="mt-3 product-text">
                                                    {{
                                                        lang == "en"
                                                            ? category.name
                                                            : category.name_ar
                                                    }}
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                </a>
                            </div>
                        </ng-template>
                    </swiper>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="environmentVariables.CATEGORY_STYLE === 'grid'">
            <h3
                class="lable title py-2 px-3 border-background-none"
                style="font-size: 1.4rem !important"
            >
                {{ "productDetails.featuredCategories" | translate }}
            </h3>
            <div class="my-4">
                <div class="row categories-collection">
                    <div
                        class="p-0"
                        style="cursor: pointer; margin-bottom: 3rem"
                        *ngFor="let category of allFeaturedCategories"
                    >
                        <a
                            style="margin: 0px auto !important"
                            class="brand-item"
                            (click)="rediectToProductPage(category)"
                        >
                            <!-- [routerLink]="
          ['/' + lang + (environmentVariables?.ENABLE_CATEGORY_VIEW ? '/category': '/products')]
          "
          [queryParams]="{
            category_id: category?.id,
            category_name:
                lang == 'ar' &&
                category.name_ar
                    ? category.name_ar
                    : category.name
          }" -->
                            <!-- (click)="rediectToProductPage(category)" -->

                            <div
                                class="imgContainer mx-2"
                                [ngClass]="{
                                    'radius-50 shadow':
                                        categoryTypeData?.isSqure == 'round'
                                }"
                            >
                                <img
                                    loading="lazy"
                                    [ngClass]="{
                                        'radius-50 shadow':
                                            categoryTypeData?.isSqure == 'round'
                                    }"
                                    [src]="category.image"
                                    [alt]="category.image"
                                    class="swiper-lazy"
                                    onError="this.src='./assets/images/placeholder200.jpg';"
                                    default="./assets/images/placeholder200.jpg"
                                    style="
                                        position: relative;
                                        top: 0px;
                                        left: 0px;
                                        margin-left: 0px;
                                        margin-right: 0px;
                                        object-fit: contain;
                                    "
                                />
                                <h3 class="text-center product-text my-3">
                                    {{
                                        lang == "en"
                                            ? category.name
                                            : category.name_ar
                                    }}
                                </h3>
                            </div>

                            <!-- <div class="text-center f-text">
          <h3 style="color: var(--secoundry-color);">
            {{ lang == "en" ? category.name : category.name_ar }}
          </h3>
        </div> -->
                        </a>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</ng-container>
